import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import useTheme from '@material-ui/core/styles/useTheme';
import { useDialogState } from '~/modules/common/hooks';

import RequestActionButton from './RequestActionButton';
import ResourcingValidationErrorDialog from './ResourcingValidationErrorDialog';

const getErrorDetails = errorCode => {
  if (
    errorCode === 'ALLOCATION_CREATION_STATUS_ERROR' ||
    errorCode === 'MARK_REQUEST_COMPLETE_STATUS_ERROR'
  ) {
    return {
      hasError: true,
      messageId:
        errorCode === 'ALLOCATION_CREATION_STATUS_ERROR'
          ? 'resourcingValidationErrorDialog.createAllocationError'
          : 'resourcingValidationErrorDialog.markRequestCompleteError'
    };
  }

  return { hasError: false, messageId: null };
};

const CompleteRequestActionButton = ({
  className,
  onClick,
  error,
  ...otherProps
}) => {
  const theme = useTheme();
  const intl = useIntl();

  const {
    open: showErrorDialog,
    openDialog: openErrorDialog,
    closeDialog: closeErrorDialog
  } = useDialogState();
  const [errorMessageId, setErrorMessageId] = useState(null);

  const handleRefresh = useCallback(() => {
    closeErrorDialog();
    window.location.reload();
  }, [closeErrorDialog]);

  useEffect(() => {
    const errorCode = error?.graphQLErrors?.[0]?.extensions?.code;
    const { hasError, messageId } = getErrorDetails(errorCode);

    if (hasError) {
      openErrorDialog();
      setErrorMessageId(messageId);
    }
  }, [error, openErrorDialog]);

  return (
    <>
      <RequestActionButton
        className={className}
        paletteClass={theme.palette.resourceRequest.complete}
        onClick={onClick}
        label={intl.formatMessage({ id: 'resourceAssignmentDialog.completed' })}
        {...otherProps}
      />

      {showErrorDialog && (
        <ResourcingValidationErrorDialog
          open={showErrorDialog}
          onClose={closeErrorDialog}
          onRefresh={handleRefresh}
          errorMessageId={errorMessageId}
        />
      )}
    </>
  );
};

CompleteRequestActionButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  error: PropTypes.object
};

export default CompleteRequestActionButton;
